export default {"src":"/_next/static/media/ic-pagination-next-disabled.471ad281.svg","height":15,"width":10,"blurWidth":0,"blurHeight":0};